import React from "react";
import logo from "./logo.gif";

const SplashScreen = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 p-0">
          <div className="min-vh-100 text-center m-0 d-flex flex-column justify-content-center">
            <img src={logo} alt="logo" className="" style={{ width: "70%", height: "auto", margin: "auto" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
